import { Component } from '@angular/core';

@Component({
  selector: 'app-ranking-update-data',
  templateUrl: './ranking-update-data.component.html',
  styleUrls: ['./ranking-update-data.component.scss'],
})
export class RankingUpdateDataComponent {}
